"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, RefObject, useCallback, useEffect, useRef } from "react";
type ScrollspyProps = {
  children: ReactNode;
  targetRef?: RefObject<HTMLElement | HTMLDivElement | Document | null | undefined>;
  onUpdate?: (id: string) => void;
  offset?: number;
  smooth?: boolean;
  className?: string;
  dataAttribute?: string;
  history?: boolean;
  throttleTime?: number;
};
export function Scrollspy(t0) {
  const $ = _c(28);
  const {
    children,
    targetRef,
    onUpdate,
    className,
    offset: t1,
    smooth: t2,
    dataAttribute: t3,
    history: t4
  } = t0;
  const offset = t1 === undefined ? 0 : t1;
  const smooth = t2 === undefined ? true : t2;
  const dataAttribute = t3 === undefined ? "scrollspy" : t3;
  const history = t4 === undefined ? true : t4;
  const selfRef = useRef(null);
  const anchorElementsRef = useRef(null);
  const prevIdTracker = useRef(null);
  let t5;
  if ($[0] !== dataAttribute || $[1] !== history || $[2] !== onUpdate) {
    t5 = (sectionId, t6) => {
      const force = t6 === undefined ? false : t6;
      anchorElementsRef.current?.forEach(item => {
        const id = item.getAttribute(`data-${dataAttribute}-anchor`);
        if (sectionId && id === sectionId) {
          item.setAttribute("data-active", "true");
        } else {
          item.removeAttribute("data-active");
        }
      });
      if (onUpdate) {
        onUpdate(sectionId || "");
      }
      if (history && (force || prevIdTracker.current !== sectionId)) {
        if (sectionId) {
          window.history.replaceState({}, "", `#${sectionId}`);
        } else {
          window.history.replaceState({}, "", window.location.pathname + window.location.search);
        }
      }
      prevIdTracker.current = sectionId;
    };
    $[0] = dataAttribute;
    $[1] = history;
    $[2] = onUpdate;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const setActiveSection = t5;
  let t6;
  if ($[4] !== dataAttribute || $[5] !== offset || $[6] !== setActiveSection || $[7] !== targetRef) {
    t6 = () => {
      if (!anchorElementsRef.current || anchorElementsRef.current.length === 0) {
        return;
      }
      let scrollElement = targetRef?.current === document ? document.documentElement : targetRef?.current as HTMLElement;
      if (!scrollElement) {
        return;
      }
      const viewport = scrollElement.querySelector("[data-slot=\"scroll-area-viewport\"]");
      if (viewport instanceof HTMLElement) {
        scrollElement = viewport;
      }
      const scrollTop = scrollElement === document.documentElement ? window.scrollY || document.documentElement.scrollTop : scrollElement.scrollTop;
      let activeIdx = -1;
      let minDelta = Infinity;
      anchorElementsRef.current.forEach((anchor, idx) => {
        const sectionId_0 = anchor.getAttribute(`data-${dataAttribute}-anchor`);
        const sectionElement = document.getElementById(sectionId_0);
        if (!sectionElement) {
          return;
        }
        let customOffset = offset;
        const dataOffset = anchor.getAttribute(`data-${dataAttribute}-offset`);
        if (dataOffset) {
          customOffset = parseInt(dataOffset, 10);
        }
        if (sectionElement.offsetTop - customOffset <= scrollTop) {
          const delta = scrollTop - (sectionElement.offsetTop - customOffset);
          if (delta < minDelta) {
            minDelta = delta;
            activeIdx = idx;
          }
        }
      });
      const scrollHeight = (scrollElement as HTMLElement).scrollHeight;
      const clientHeight = (scrollElement as HTMLElement).clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 2 && anchorElementsRef.current.length > 0) {
        activeIdx = anchorElementsRef.current.length - 1;
      }
      const activeAnchor = activeIdx !== -1 ? anchorElementsRef.current[activeIdx] : null;
      const sectionId_1 = activeAnchor?.getAttribute(`data-${dataAttribute}-anchor`) || null;
      setActiveSection(sectionId_1);
    };
    $[4] = dataAttribute;
    $[5] = offset;
    $[6] = setActiveSection;
    $[7] = targetRef;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleScroll = t6;
  let t7;
  if ($[9] !== dataAttribute || $[10] !== offset || $[11] !== setActiveSection || $[12] !== smooth || $[13] !== targetRef) {
    t7 = anchorElement => event => {
      if (event) {
        event.preventDefault();
      }
      const sectionId_2 = anchorElement.getAttribute(`data-${dataAttribute}-anchor`)?.replace("#", "") || null;
      if (!sectionId_2) {
        return;
      }
      const sectionElement_0 = document.getElementById(sectionId_2);
      if (!sectionElement_0) {
        return;
      }
      let scrollToElement = targetRef?.current === document ? window : targetRef?.current as HTMLElement;
      if (scrollToElement instanceof HTMLElement) {
        const viewport_0 = scrollToElement.querySelector("[data-slot=\"scroll-area-viewport\"]");
        if (viewport_0 instanceof HTMLElement) {
          scrollToElement = viewport_0;
        }
      }
      let customOffset_0 = offset;
      const dataOffset_0 = anchorElement.getAttribute(`data-${dataAttribute}-offset`);
      if (dataOffset_0) {
        customOffset_0 = parseInt(dataOffset_0, 10);
      }
      const scrollTop_0 = sectionElement_0.offsetTop - customOffset_0;
      if (scrollToElement && "scrollTo" in scrollToElement) {
        scrollToElement.scrollTo({
          top: scrollTop_0,
          left: 0,
          behavior: smooth ? "smooth" : "auto"
        });
      }
      setActiveSection(sectionId_2, true);
    };
    $[9] = dataAttribute;
    $[10] = offset;
    $[11] = setActiveSection;
    $[12] = smooth;
    $[13] = targetRef;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const scrollTo = t7;
  let t8;
  if ($[15] !== dataAttribute || $[16] !== scrollTo) {
    t8 = () => {
      const hash = CSS.escape(window.location.hash.replace("#", ""));
      if (hash) {
        const targetElement = document.querySelector(`[data-${dataAttribute}-anchor="${hash}"]`) as HTMLElement;
        if (targetElement) {
          scrollTo(targetElement)();
        }
      }
    };
    $[15] = dataAttribute;
    $[16] = scrollTo;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const scrollToHashSection = t8;
  let t10;
  let t9;
  if ($[18] !== dataAttribute || $[19] !== handleScroll || $[20] !== scrollTo || $[21] !== scrollToHashSection || $[22] !== targetRef) {
    t9 = () => {
      if (selfRef.current) {
        anchorElementsRef.current = Array.from(selfRef.current.querySelectorAll(`[data-${dataAttribute}-anchor]`));
      }
      const currentAnchors = anchorElementsRef.current;
      currentAnchors?.forEach(item_0 => {
        item_0.addEventListener("click", scrollTo(item_0 as HTMLElement));
      });
      const onScroll = event_0 => {
        const scrollElement_0 = targetRef?.current === document ? window : targetRef?.current as HTMLElement;
        if (!scrollElement_0) {
          return;
        }
        if (scrollElement_0 === window || scrollElement_0 instanceof HTMLElement && scrollElement_0.contains(event_0.target as Node)) {
          handleScroll();
        }
      };
      window.addEventListener("scroll", onScroll, true);
      const initialTimeout = setTimeout(() => {
        scrollToHashSection();
        handleScroll();
      }, 100);
      return () => {
        window.removeEventListener("scroll", onScroll, true);
        currentAnchors?.forEach(item_1 => {
          item_1.removeEventListener("click", scrollTo(item_1 as HTMLElement));
        });
        clearTimeout(initialTimeout);
      };
    };
    t10 = [targetRef, selfRef, handleScroll, dataAttribute, scrollTo, scrollToHashSection];
    $[18] = dataAttribute;
    $[19] = handleScroll;
    $[20] = scrollTo;
    $[21] = scrollToHashSection;
    $[22] = targetRef;
    $[23] = t10;
    $[24] = t9;
  } else {
    t10 = $[23];
    t9 = $[24];
  }
  useEffect(t9, t10);
  let t11;
  if ($[25] !== children || $[26] !== className) {
    t11 = <div data-slot="scrollspy" className={className} ref={selfRef}>{children}</div>;
    $[25] = children;
    $[26] = className;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}